import { Button } from "@/components/ui/button";
import type { Passenger } from "@/types/booking-history/bookinghistorydetail";
import { useNavigate } from "react-router-dom";

type BoardingPassCardProps = {
  passengers: Passenger[];
  paymentId: string | undefined;
};

export function BoardingPassCard({
  passengers,
  paymentId,
}: BoardingPassCardProps) {
  const navigate = useNavigate();

  const handleCompletePassengerDetails = () => {
    navigate(`/booking-history/passenger/${paymentId}`, {
      state: {
        passengers,
        passengerIndex: 0,
      },
    });
  };

  return (
    <div>
      <h2 className="mt-8 text-lg font-semibold text-secondary-foreground">
        Boarding Passes
      </h2>

      <section className="mt-2 rounded-2xl bg-card p-4 shadow-xl">
        <div className="grid grid-cols-1 items-center md:grid-cols-2">
          <div>
            <h3 className="text-sm font-semibold text-secondary-foreground md:text-base">
              Passenger Details Required
            </h3>

            <p className="mt-2 text-sm font-medium leading-tight text-muted">
              Complete the details for all passengers to access your boarding
              passes.
            </p>
          </div>

          <div className="mt-4 flex items-center justify-end md:mt-0">
            <Button
              type="button"
              variant="secondary"
              className="w-full cursor-pointer md:w-2xs"
              onClick={handleCompletePassengerDetails}
            >
              Complete Passenger Details
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}